import { api } from '@/main'
import router from '@/router'
import defaults from 'lodash.defaults'

const defaultState = {
  records: null,
  currentRecord: null,
  currentRecordMessages: []
}

export default {
  namespaced: true,
  state: {
    ...defaultState
  },
  mutations: {
    RESET_MODULE: state => {
      Object.keys(state).forEach(key => {
        state[key] = defaultState[key]
      })
    },
    SET_RECORDS: (state, records) => (state.records = records),
    SET_CURRENT_RECORD: (state, currentRecord) =>
      (state.currentRecord = currentRecord),
    SET_CURRENT_RECORD_MESSAGES: (state, messages) =>
      (state.currentRecordMessages = messages),
    ADD_PERSON_TO_CURRENT_RECORD: (state, params) => {
      if (params.type === 'guarantor') {
        state.currentRecord.guarantor_ids.push(params.id)
      } else if (params.type === 'tenant') {
        state.currentRecord.tenant_ids.push(params.id)
      }
    },
    RESET_MESSAGES: state => (state.currentRecordMessages = []),
    ADD_NEW_MESSAGE: (state, message) => {
      state.currentRecordMessages.push(message)
    },
    UPDATE_MESSAGE: (state, message) => {
      state.currentRecordMessages = [
        ...state.currentRecordMessages.filter(m => m.id !== message.id),
        message.data
      ]
    }
  },
  actions: {
    resetModule(store) {
      store.commit('RESET_MODULE')
    },
    async createRecord(store, params) {
      const r = await api.records.createRecord(params)

      if (r) {
        if (r.offer) {
          store.dispatch('residences/setSelectedAccomodation', r.offer, {
            root: true
          })
        }

        if (r.residence) {
          store.dispatch('residences/setSelectedResidence', r.residence.id, {
            root: true
          })
        }

        router.push({
          path: '/dossiers/' + r.id + '/ajout-de-locataire'
        })
      }

      store.commit('SET_CURRENT_RECORD', r)
    },
    async updateRecord(store, params) {
      const r = await api.records.updateRecord(params)

      store.commit('SET_CURRENT_RECORD', r)

      if (r.state === 'granted_accepted') {
        window.google_analytics_pageview('/dossiers/confirmation')
      }

      await store.dispatch('recordsPeople/getCurrentRecordPeople', null, {
        root: true
      })

      await store.dispatch(
        'recordsDocuments/getCurrentRecordPeopleDocuments',
        null,
        {
          root: true
        }
      )

      return r
    },
    async getRecords(store) {
      const r = await api.records.getRecords()

      store.commit('SET_RECORDS', r)
    },
    async getRecord(store, params) {
      const r = await api.records.getRecord(params)

      store.commit('RESET_MESSAGES')

      if (store.rootState.customer.current_record_id !== params.id) {
        await api.customer.updateUser({
          registration: {
            current_record_id: params.id
          }
        })
      }

      if (r.offer) {
        store.dispatch('residences/setSelectedAccomodation', r.offer, {
          root: true
        })
      }

      if (r.residence) {
        store.dispatch('residences/setSelectedResidence', r.residence.id, {
          root: true
        })
      }

      store.commit('SET_CURRENT_RECORD', r)

      if (r.tenant_ids || r.guarantor_ids) {
        await store.dispatch('recordsPeople/getCurrentRecordPeople', null, {
          root: true
        })

        await store.dispatch(
          'recordsDocuments/getCurrentRecordPeopleDocuments',
          null,
          {
            root: true
          }
        )
      }

      await store.dispatch('getMessages')
    },
    async sendMessage(store, params) {
      const r = await api.records.sendMessage(params)

      store.commit('ADD_NEW_MESSAGE', r)
    },
    async updateMessage(store, params) {
      const r = await api.records.updateMessage(params)

      store.commit('UPDATE_MESSAGE', {
        id: params.messageId,
        data: r
      })
    },
    addPersonToCurrentRecord(store, params) {
      store.commit('ADD_PERSON_TO_CURRENT_RECORD', params)
    },
    async refreshCurrentRecord(store, params) {
      defaults(params, {
        withPeople: true
      })

      if (store.state.currentRecord) {
        const r = await api.records.getRecord({
          id: store.state.currentRecord.id
        })

        store.commit('SET_CURRENT_RECORD', r)

        if (params.withPeople) {
          await store.dispatch('recordsPeople/getCurrentRecordPeople', null, {
            root: true
          })
        }
      }
    },
    async getMessages(store) {
      const r = await api.records.getMessages({
        recordId: store.state.currentRecord.id
      })

      store.commit('SET_CURRENT_RECORD_MESSAGES', r)
    },
    async detachPerson(store, params) {
      const payload = {}

      if (params.type) {
        if (params.type === 'guarantor' || params.type === 'guarant') {
          payload.guarantor_ids = store.state.currentRecord.guarantor_ids.filter(
            item => item !== params.id
          )
        }

        if (params.type === 'tenant') {
          payload.tenant_ids = store.state.currentRecord.tenant_ids.filter(
            item => item !== params.id
          )
        }
      }

      await store.dispatch('updateRecord', {
        id: params.recordId,
        record: payload
      })
    }
  },
  getters: {
    currentRecord: state => state.currentRecord
  }
}
